import { render, staticRenderFns } from "./ProxiesView.vue?vue&type=template&id=3f26cfc8&scoped=true&"
import script from "./ProxiesView.vue?vue&type=script&lang=ts&"
export * from "./ProxiesView.vue?vue&type=script&lang=ts&"
import style0 from "./ProxiesView.vue?vue&type=style&index=0&id=3f26cfc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f26cfc8",
  null
  
)

export default component.exports